export default __webpack_public_path__ + "static/media/au_brnt.f97488ea.jpg";